
    <div class="consent-container">
        <div class="consent-card">
            <div class="consent-header">
                <h1 class="consent-title">Important Instructions - NFC Scan</h1>
            </div>
            
            <div class="consent-content">
                <p class="consent-text">
                    Note: Before starting the identification process, please make sure that the valid ID document you are using has an NFC icon (see graphic). </p>
                    <p class="consent-text"> 
                    <img src="assets/nfc-e-pass-icon.svg" alt="NFC Pass Icon" class="nfc-icon">
                    </p>
                     <p class="consent-text">
                    If the icon is visible on your ID, it supports the required NFC scan for data transmission and you can complete the process with all three steps (ID, NFC and face scan) according to the instructions.
                </p>
                <p class="consent-text">
                  If your ID document does not contain an NFC chip, you can skip the second step of identification (“Read biometric data”) and complete the identification process without it.
                </p>
            </div>
            
            <div class="consent-checkbox">
                <label class="checkbox-container">
                    <input 
                        type="checkbox" 
                        [(ngModel)]="consentAccepted"
                        class="checkbox-input"
                        id="consent-checkbox"
                    />
                    <span class="checkmark"></span>
                    <span class="checkbox-text">
                        I hereby confirm that I have read and understood the above information and will complete the identification process including all possible steps (based on my ID document).
                    </span>
                </label>
            </div>
            
            <button 
                class="consent-button" 
                [disabled]="!consentAccepted"
                [class.disabled]="!consentAccepted"
                (click)="proceedToIdentification()"
                type="button"
            >
                Continue
            </button>
            
            <ngx-spinner size="medium" [type]="typeSelected"></ngx-spinner>
        </div>
    </div>